<div class="page-container">
    <div class="page-body-container">
		<div class="card h-full md:h-auto md:w-2/6">
			<div class="card-header-container">
				<h1 class="card-header">Passwort zurücksetzen</h1>
			</div>
			<div class="form-group">
				<div class="form-control">
					<label>Temporäres Passwort aus Ihrer E-Mail</label>
					<input matInput [type]="hidePasswordSec ? 'password' : 'text'" [formControl]="temporaryPasswordControl"
						   placeholder="Temporäres Passwort aus Ihrer E-Mail">
					<i class="fa-solid absolute right-3 top-11 text-preorder-accordion-background text-xl cursor-pointer"
					   (click)="hidePasswordSec = !hidePasswordSec"
					   [ngClass]="{'fa-eye': !hidePasswordSec, 'fa-eye-slash': hidePasswordSec}"></i>
				</div>
				<div class="form-control">
					<label>Neues Passwort</label>
					<input matInput [type]="hidePassword ? 'password' : 'text'" [formControl]="newPasswordControl" placeholder="Neues Passwort">
					<i class="fa-solid absolute right-3 top-11 text-preorder-accordion-background text-xl cursor-pointer"
					   (click)="hidePassword = !hidePassword"
					   [ngClass]="{'fa-eye': !hidePassword, 'fa-eye-slash': hidePassword}"></i>
					@if (newPasswordControl!.dirty && newPasswordControl!.errors) {
						<div class="flex flex-col gap-2">

							@if (newPasswordControl!.errors!['minLength']) {
								<div class="text-preorder-orange text-sm">- Mindestens 12
									Zeichen
								</div>
							}
							@if (newPasswordControl!.errors!['minLowerCase']) {
								<div class="text-preorder-orange text-sm">- Mindestens 1
									Kleinbuchstabe
								</div>
							}
							@if (newPasswordControl!.errors!['minUpperCase']) {
								<div class="text-preorder-orange text-sm">- Mindestens 1
									Großbuchstabe
								</div>
							}
							@if (newPasswordControl!.errors!['minDigits']) {
								<div class="text-preorder-orange text-sm">- Mindestens 1 Ziffer
								</div>
							}
							@if (newPasswordControl!.errors!['minSpecialCharacters']) {
								<div class="text-preorder-orange text-sm">- Mindestens 1
									Sonderzeichen
								</div>
							}

						</div>
					}
				</div>
				<div class="form-control">
					<label>Passwort wiederholen *</label>
					<input [type]="hidePasswordConfirm ? 'password' : 'text'" matInput
						   placeholder="Passwort wiederholen"
						   [formControl]="passwordConfirmControl">
					<i class="fa-solid absolute right-3 top-11 lg:text-canna-card-background-sec text-canna-primary text-xl cursor-pointer"
					   (click)="hidePasswordConfirm = !hidePasswordConfirm"
					   [ngClass]="{'fa-eye': !hidePasswordConfirm, 'fa-eye-slash': hidePasswordConfirm}"></i>
					@if (passwordConfirmControl!.valid && newPasswordControl!.value !== passwordConfirmControl!.value) {
						<mat-error>* Passwörter stimmen nicht überein</mat-error>
					}
				</div>
			</div>
			<div class="button-row">
				<button class="btn-primary" (click)="saveNewPassword()">
					<span>Neues Passwort speichern</span>
					<i class="fa-solid fa-angle-right self-center text-md pl-2"></i>
				</button>
			</div>
        </div>
    </div>
</div>
